(() => {
  const normalize = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  function getInitialVariantFromSection(productInfoEl) {
    const script = productInfoEl?.querySelector('variant-selects script[data-selected-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function togglePersonalizacao(wrapper, variant) {
    if (!wrapper) return;

    const nomeField = wrapper.querySelector('.field-nome');
    const numeroField = wrapper.querySelector('.field-numero');
    const fraseField = wrapper.querySelector('.field-frase');

    const nomeInput = wrapper.querySelector('input[name="properties[Nome]"]');
    const numeroInput = wrapper.querySelector('input[name="properties[Número]"]');
    const fraseInput = wrapper.querySelector('input[name="properties[Frase]"]');

    const options = Array.isArray(variant?.options) ? variant.options : [];

    // Detecta qual tipo de personalização foi selecionada
    const isFrase = options.some((opt) => normalize(opt) === "frase");
    const isNomeNumero = options.some((opt) => {
      const n = normalize(opt);
      return n.includes("nome e numero") || n === "personalizar";
    });

    const hasPersonalizar = isFrase || isNomeNumero;

    if (hasPersonalizar) {
      wrapper.classList.remove("hidden");

      if (isFrase) {
        // Frase: mostra só o campo Frase, esconde Nome e Número
        if (nomeField) nomeField.style.display = "none";
        if (numeroField) numeroField.style.display = "none";
        if (fraseField) fraseField.style.display = "";

        if (nomeInput) { nomeInput.value = ""; nomeInput.disabled = true; }
        if (numeroInput) { numeroInput.value = ""; numeroInput.disabled = true; }
        if (fraseInput) fraseInput.disabled = false;
      } else {
        // Nome e Número: mostra Nome e Número, esconde Frase
        if (nomeField) nomeField.style.display = "";
        if (numeroField) numeroField.style.display = "";
        if (fraseField) fraseField.style.display = "none";

        if (nomeInput) nomeInput.disabled = false;
        if (numeroInput) numeroInput.disabled = false;
        if (fraseInput) { fraseInput.value = ""; fraseInput.disabled = true; }
      }
    } else {
      // Sem personalização: esconde tudo e limpa
      wrapper.classList.add("hidden");

      if (nomeInput) { nomeInput.value = ""; nomeInput.disabled = true; }
      if (numeroInput) { numeroInput.value = ""; numeroInput.disabled = true; }
      if (fraseInput) { fraseInput.value = ""; fraseInput.disabled = true; }

      if (nomeField) nomeField.style.display = "";
      if (numeroField) numeroField.style.display = "";
      if (fraseField) fraseField.style.display = "none";
    }
  }

  function initPersonalizacaoForProductInfo(productInfoEl) {
    const sectionId = productInfoEl?.dataset?.section;
    if (!sectionId) return;

    const wrapper = productInfoEl.querySelector(`[data-personalizacao-wrapper][data-section-id="${sectionId}"]`);
    if (!wrapper) return;

    // 1) estado inicial
    const initialVariant = getInitialVariantFromSection(productInfoEl);
    togglePersonalizacao(wrapper, initialVariant);

    // 2) quando mudar variante (evento nativo do Dawn)
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data;
        if (!data || data.sectionId !== sectionId) return;
        togglePersonalizacao(wrapper, data.variant);
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-info").forEach(initPersonalizacaoForProductInfo);
  });
})();
